module.exports = __webpack_public_path__ + "media/images/patterns/bg-222554f69e246a56a0fbd53c7617e0b5.svg";